<template>
  <div class="video-cnt">
    <!-- <video autoplay loop muted playsinline id="myVideo">
      <source
        src="@/assets/images/video/Arizona Cardinals Happy Holidays 2021.mp4"
        type="video/mp4"
      />
    </video> -->
    <div class="myVideo">
      <youtube
        :player-vars="playerVars"
        ref="youtube"
        :video-id="videoId"
        width="100%"
        height="100%"
        fitparent="true"
        @ended="hideVideo()"
      ></youtube>
    </div>
    <!-- <div class="myVideo">
      <iframe
        src="https://www.youtube.com/embed/9imstdmnx1w?controls=0&modestbranding=1&autohide=1&showinfo=0&autoplay=1&mute=1&loop=1"
        title="Cardinals Holiday Card"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div> -->

    <!-- Buttons -->
    <div class="buttons">
      <b-button
        id="mute"
        class="circle-button video-button sound-button"
        :class="{ 'sound-button-on': soundButtonClicked }"
        @click="toggleVideoSound"
      >
        <div class="button-img-cnt">
          <img src="@/assets/images/video/Volume-off.svg" alt="Sound Off" />
        </div>
      </b-button>
      <b-button
        class="play-skip-button video-button skip-button"
        @click="hideVideo()"
      >
        <div class="button-text-cnt">
          <p>Skip Video</p>
          <img src="@/assets/images/icons/right-arrow.svg" alt="Right Arrow" />
        </div>
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Video",
  data() {
    return {
      videoMute: true,
      soundButtonClicked: false,
      videoId: "Jgl8dJyO8U0",
      playerVars: {
        autoplay: 1,
        controls: 0,
        modestbranding: 1,
        showinfo: 0,
        mute: 0,
        loop: 1,
        rel: 0,
        autohide: 1,
      },
    };
  },
  computed: {
    ...mapState(["global"]),
    music() {
      return this.$store.getters.getMusic;
    },
  },
  methods: {
    toggleVideoSound() {
      // let videoEl = document.getElementById("myVideo");
      // videoEl.muted = !videoEl.muted;
      this.$refs.youtube.player.isMuted()
        ? this.$refs.youtube.player.unMute()
        : this.$refs.youtube.player.mute();

      this.videoMute = !this.videoMute;
      this.soundButtonClicked = true;
      //console.log(videoEl.muted);
    },
    hideVideo() {
      this.$store.dispatch("hideVideo");
    },
  },
};
</script>

<style lang="scss" scoped>
.video-cnt {
  #myVideo {
    position: fixed;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;
  }
  .myVideo {
    width: 100vw;
    height: 100vh;
    iframe {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100vw;
      height: 100vh;
      transform: translate(-50%, -50%);
    }
    @media (min-aspect-ratio: 16/9) {
      iframe {
        /* height = 100 * (9 / 16) = 56.25 */
        height: 56.25vw;
      }
    }

    @media (max-aspect-ratio: 16/9) {
      iframe {
        /* width = 100 / (9 / 16) = 177.777777 */
        width: 177.78vh;
      }
    }
  }
  .buttons {
    .video-button {
      position: fixed;
    }
    .sound-button {
      top: calc(50% - 50px);
      left: calc(50% - 50px);
      opacity: 1;
      transition: opacity 0.5s;
      display: none;
    }
    .sound-button-on {
      display: none;
      opacity: 0;
    }
    .sound-button:hover {
      display: none;
      opacity: 0;
    }
    .skip-button {
      bottom: 24px;
      right: 25px;
      img {
        margin: 0 0 0 4px;
      }
      p {
        margin: 3px 0 0 0;
      }
    }
  }
}
@media only screen and (max-width: $lg) {
}
@media only screen and (max-width: $md) {
}
@media only screen and (max-width: $sm) {
  .video-cnt {
    .buttons {
      .sound-button {
        display: none;
      }
      .sound-button:hover {
        display: none;
      }
    }
  }
}
</style>
